import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';

export interface IHighestLevelOfQualification {
  id?: string;
  geographicLevel?: keyof typeof GeographicLevel;
  date?: string;
  geography?: string;
  geographyCode?: string;
  totalAllUsualResidents?: number | null;
  noQualifications?: number | null;
  level1Qualifications?: number | null;
  level2Qualifications?: number | null;
  apprenticeship?: number | null;
  level3Qualifications?: number | null;
  level4QualificationsAndAbove?: number | null;
  otherQualifications?: number | null;
}

export const defaultValue: Readonly<IHighestLevelOfQualification> = {};
